import type { IReportTable, ReportRowType } from '~/presentation/reports/common/type';

import { useReportControlContext } from '~/modules/report-analytic/contexts';
import { getMetricPreviousValue } from '~/presentation/reports/common';
import { useReportOrderParameter } from './useReportOrderParameters';
import { TIME_KEYS } from '~/modules/report-analytic/constants';
import { useGemxQlQuery } from '~/core/gemxql/graphql';
import { useMemo, useState } from 'react';

export const useFetchReportOrderListing = () => {
  const [enableQuery, setEnableQuery] = useState(false);
  const [overrideFilters, setOverrideFilters] = useState<ReportRowType>({});

  const { parameter, enabled } = useReportOrderParameter({ overrideFilters });

  const { dimensions } = useReportControlContext();

  const onClickOrderCell = (data: { row?: ReportRowType; isPrevious?: boolean }) => {
    const { row, isPrevious } = data;
    if (!row) return;
    const overrideFilters: ReportRowType = {};

    dimensions.forEach((dim) => {
      if (TIME_KEYS.has(dim) && isPrevious) {
        overrideFilters[dim] = getMetricPreviousValue(row, dim);
        return;
      }

      if (row[dim]) {
        overrideFilters[dim] = row[dim];
      }
    });
    onChangeOverrideFilters(overrideFilters);
  };

  const onChangeOverrideFilters = (filters: ReportRowType) => {
    setEnableQuery(() => {
      setOverrideFilters(filters);
      return true;
    });
  };

  const { data, isLoading, isFetching, error } = useGemxQlQuery(parameter, {
    enabled: enableQuery && enabled,
    retry: false,
    onSettled() {
      setEnableQuery(false);
    },
  });

  const tableData = data?.gemxQLQuery?.tableData;

  const orderList = useMemo(() => {
    if (!tableData || !tableData.columns || !tableData.rows) return { columns: [], rows: [] };

    return tableData as IReportTable;
  }, [tableData]);

  return {
    orderList,
    isLoading,
    isFetching,
    error,
    onClickOrderCell,
  };
};
